module.exports = __webpack_public_path__ + "media/images/company/cp24-98803d23e2b1edaf0218d7f8ed12b40e.png";